var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.872,
    height: 33.31,
    viewBox: "0 0 35.872 33.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8889",
    "data-name": "Path 8889",
    d: "M15.8,32.725,8.318,23.838a2.549,2.549,0,0,0-3.649,0,2.6,2.6,0,0,0,0,3.682l9.277,10.7a2.58,2.58,0,0,0,3.675,0l21.4-28.089a2.6,2.6,0,0,0,0-3.682,2.549,2.549,0,0,0-3.649,0Z",
    transform: "translate(-3.906 -5.681)",
    fill: "#1da193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done_icon.891a86cd24d2bbd355901ef28a246107.svg";
export { ForwardRef as ReactComponent };